<script>
import VTextField from 'vuetify/lib/components/VTextField';

export default {
  mixins: [ VTextField ],

  data() {
    return {
      $_isCompositionStarted: false,
    };
  },

  mounted() {
    this.$el.addEventListener('compositionstart', this.$_onCompositionstart);
    this.$el.addEventListener('compositionend', this.$_onCompositionend);
    this.$el.addEventListener('keydown', this.$_onKeydown);
  },

  beforeDestroy() {
    this.$el.removeEventListener('compositionstart', this.$_onCompositionstart);
    this.$el.removeEventListener('compositionend', this.$_onCompositionend);
    this.$el.removeEventListener('keydown', this.$_onKeydown);
  },

  methods: {
    /* private */
    $_onCompositionstart() {
      this.$data.$_isCompositionStarted = true;
    },

    $_onCompositionend() {
      this.$data.$_isCompositionStarted = false;
    },

    $_onKeydown(event) {
      if (this.$data.$_isCompositionStarted) {
        event.stopPropagation();
      } else {
        this.$emit('keydown', event);
      }
    },
  },
}
</script>